import React, { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { PublicLayout } from "@/components/site/PublicLayout";
import { AdminLayout } from "@/components/site/AdminLayout";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";
import { CRMLayout } from "@/components/site/CRMLayout";
import { ScrollToTop } from "@/components/site/ScrollToTop";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Services from "@/pages/public/Services";
import Testimonials from "@/pages/public/Testimonials";
import Contacts from "@/pages/public/Contacts";
import Privacy from "@/pages/public/Privacy";
import CookiePolicy from "@/pages/public/CookiePolicy";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArtists from "@/pages/admin/AdminArtists";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminContent from "@/pages/admin/AdminContent";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminCredentialsChecklist from "@/pages/admin/AdminCredentialsChecklist";
import AdminValues from "@/pages/admin/AdminValues";
import AdminPrivacyReport from "@/pages/admin/AdminPrivacyReport";
import AdminMioGiorno from "@/pages/admin/AdminMioGiorno";
import AdminContratti from "@/pages/admin/AdminContratti";
import AdminSetting from "@/pages/admin/AdminSetting";
import AdminServiziContratto from "@/pages/admin/AdminServiziContratto";
import AdminVenditori from "@/pages/admin/AdminVenditori";
import AdminReport from "@/pages/admin/AdminReport";
import AdminReportKPI from "@/pages/admin/AdminReportKPI";
import AdminDashboardOperatore from "@/pages/admin/AdminDashboardOperatore";
import AdminSetup from "@/pages/admin/AdminSetup";

import CRMLogin from "@/pages/crm/CRMLogin";
import CRMDashboard from "@/pages/crm/CRMDashboard";
import CRMLeads from "@/pages/crm/CRMLeads";
import CRMUsers from "@/pages/crm/CRMUsers";
import CRMPackages from "@/pages/crm/CRMPackages";
import CRMSettings from "@/pages/crm/CRMSettings";
import CRMMaterials from "@/pages/crm/CRMMaterials";
import CRMReports from "@/pages/crm/CRMReports";

function App() {
  useEffect(() => {
    document.title = "Perla Music — Music Management";
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<About />} />
              <Route path="/servizi" element={<Services />} />
              <Route path="/testimonianze" element={<Testimonials />} />
              <Route path="/contatti" element={<Contacts />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
            </Route>

            {/* Admin (CMS) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/mio-giorno" element={<AdminMioGiorno />} />
              <Route path="/admin/home" element={<AdminDashboardOperatore />} />
              <Route path="/admin/setup" element={<AdminSetup />} />
              <Route path="/admin/contratti" element={<AdminContratti />} />
              <Route path="/admin/setting" element={<AdminSetting />} />
              <Route path="/admin/servizi-contratto" element={<AdminServiziContratto />} />
              <Route path="/admin/venditori" element={<AdminVenditori />} />
              <Route path="/admin/report" element={<AdminReport />} />
              <Route path="/admin/report-kpi" element={<AdminReportKPI />} />
              <Route path="/admin/artists" element={<AdminArtists />} />
              <Route path="/admin/testimonials" element={<AdminTestimonials />} />
              <Route path="/admin/team" element={<AdminTeam />} />
              <Route path="/admin/content" element={<AdminContent />} />
              <Route path="/admin/valori" element={<AdminValues />} />
              <Route path="/admin/report-privacy" element={<AdminPrivacyReport />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/admin/credenziali-crm" element={<AdminCredentialsChecklist />} />
            </Route>

            {/* CRM (Fase 2) — Admin, Seller, Outreach, Artist */}
            <Route path="/crm/login" element={<CRMLogin />} />
            <Route element={<CRMLayout />}>
              <Route path="/crm" element={<CRMDashboard />} />
              <Route path="/crm/leads" element={<CRMLeads />} />
              <Route path="/crm/users" element={<CRMUsers />} />
              <Route path="/crm/packages" element={<CRMPackages />} />
              <Route path="/crm/materiali" element={<CRMMaterials />} />
              <Route path="/crm/report" element={<CRMReports />} />
              <Route path="/crm/impostazioni" element={<CRMSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
